import React from 'react'
import formStyles from '../../branding/formStyles'

export default function OnfsFormGroup({
  name,
  label,
  children,
  description,
  ...rest
}) {
  const fieldSetProps = {
    id: name,
    style: formStyles.group.fieldset
  }

  if (description) {
    fieldSetProps['aria-describedby'] = `description_${name}`
  }

  return (
    <fieldset {...fieldSetProps} {...rest}>
      <legend style={formStyles.group.legend}>{label}</legend>
      {description && (
        <p id={`description_${name}`} style={formStyles.group.description}>
          {description}
        </p>
      )}
      <div>{children}</div>
    </fieldset>
  )
}
